import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material";
import { Button } from "@covertree/ui/buttons/Button";
import DisplayPropertiesTableWithBackground from "@covertree/ui/content/DisplayPropertiesTableWithBackground";

import {
  createSearchParams,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";

import { useAppSelector } from "@redux/hooks/useAppSelector";
import {
  resetExternalCoverageData,
  resetPolicyTypeForm,
  selectAddedCoverageDetails,
} from "@redux/coverages/coveragesSlice";
import { mapResidentInsuranceAdoptionStatus } from "@redux/residents/utils";
import { formatAwsDateString } from "@covertree/utils";

import { TllCoverageStatus } from "@graphql/api";
import { moveBackInPathname } from "@utils";
import useAppDispatch from "@redux/hooks/useAppDispatch";

export default function CoverageAdded() {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();

  const {
    updatedResident: resident,
    cancelledTll,
    residentStatusChanged,
    alreadyAddedCoverageStatus: alreadyAddedTllStatus,
  } = useAppSelector(selectAddedCoverageDetails);

  const handleClose = () => {
    dispatch(resetExternalCoverageData());
    dispatch(resetPolicyTypeForm());
    navigate(
      {
        pathname: moveBackInPathname(location.pathname, 2),
        search: createSearchParams(searchParams).toString(),
      },
      { replace: true }
    );
  };

  if (!resident) {
    return (
      <>
        <Typography lineHeight="400%">
          Page not found. Contact us or try again later.
        </Typography>
      </>
    );
  }
  return (
    <Grid
      container
      display="flex"
      direction="column"
      gap={4}
      alignItems="flex-start"
      justifyContent="space-around">
      <img
        src="/images/icons/checkmark.webp"
        alt="success"
        width={80}
        height={80}
      />
      <Grid item xs={12}>
        <Typography fontSize={theme.spacing(4)}>
          New Proof Of Coverage Added
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography fontSize={theme.spacing(2.5)}>
          Proof of coverage has been successfully added to the system
          {residentStatusChanged ? (
            <Typography component="span">
              . Residents Insurance Adoption Status was set to{" "}
              <Typography component="span" color="secondary.main">
                {mapResidentInsuranceAdoptionStatus(
                  resident.insuranceAdoption.status
                )}
              </Typography>
              .
            </Typography>
          ) : (
            <Typography component="span">
              {" "}
              without change in Insurance Adoption Status.
            </Typography>
          )}
        </Typography>
      </Grid>
      {!!cancelledTll && (
        <Grid item xs={12} width="100%" container gap={4}>
          <Typography>
            {alreadyAddedTllStatus === TllCoverageStatus.ScheduledCancellation
              ? "BRL policy insurance"
              : "Issued BRL policy insurance"}{" "}
            will be cancelled for this resident.
          </Typography>
          <DisplayPropertiesTableWithBackground
            properties={[
              {
                label: "Cancellation Effective Date",
                value:
                  alreadyAddedTllStatus ===
                  TllCoverageStatus.ScheduledCancellation
                    ? formatAwsDateString(
                        cancelledTll.policyCancellationEffectiveDate
                      )
                    : formatAwsDateString(cancelledTll.policyEndDate),
              },
              {
                label: "Cancellation Reason",
                value:
                  alreadyAddedTllStatus ===
                  TllCoverageStatus.ScheduledCancellation
                    ? cancelledTll.policyCancellationReason
                    : cancelledTll.policyEndReason,
              },
            ]}
          />
        </Grid>
      )}
      <Button onClick={handleClose}>Close</Button>
    </Grid>
  );
}
